export default {
  LOGIN: 'Login',
};
